import { INSURANCE_TYPE } from "./insuranceTypeUtils";
import { trackEvent } from '../services/api/TrackingService.js'
import { sleep } from "./common.js";

export const HIKIUKE_TAB_LIMIT = 15;

export const PDF_WIDTH_PORTAIT = 740;
export const PDF_WIDTH_LANDSCAPE = 1240;

export const openHikiukeDetail = async (results, setSelectedSearchResult) => {
  // 検索結果クリック操作のトラッキング
  for (const result of results) {
    const { company: companyName } = parsePathString(result.pdfUrl);
    trackEvent({
      name: "SearchResultClicked",
      properties: {
        queryId: result.queryId,
        title: result.pdfUrl,
        pages: result.pages,
        diseaseName: result.diseaseName,
        company: companyName,
        similarity: result.similarity,
        pdfUrl: result.pdfUrl
      }
    }).catch(error => console.error('検索結果クリックログ送信エラー:', error));
  }

  setSelectedSearchResult({
    ...results,
    insuranceType: INSURANCE_TYPE.HIKIUKE
  });

  await sleep(100);

  for (let i = 0; i < results.length; i++) {
    window.open(`/solicitor/insurance/hikiuke/detail/${i}`, '_blank', 'noopener,noreferrer');
  }
}

export const openDetail = (result, insuranceType, setSelectedSearchResult) => {
  const { company: companyName } = parsePathString(result.pdfUrl);

  // 検索結果クリック操作のトラッキング
  trackEvent({
    name: "SearchResultClicked",
    properties: {
      queryId: result.queryId,
      title: result.title,
      pages: result.pages,
      diseaseName: '',
      company: companyName,
      similarity: result.similarity,
      pdfUrl: result.pdfUrl
    }
  }).catch(error => console.error('検索結果クリックログ送信エラー:', error));

  openDetailInner(`/solicitor/insurance/system/detail`, result, companyName, insuranceType, setSelectedSearchResult);
}

const openDetailInner = async (url, result, companyName, insuranceType, setSelectedSearchResult) => {
  setSelectedSearchResult({
    ...result,
    companyName,
    insuranceType
  });

  // 念のため同期が完了するのを少し待ってから別タブを開く
  await sleep(100);

  window.open(url, '_blank', 'noopener,noreferrer');

  // window.openを待機 (後続の処理がある場合に備えて)
  await sleep(100);
}

/**
 * パス文字列を解析する関数
 * @param {string} pathString 
 * @returns {{company: string|null, title: string|null}} パス解析結果
 */
export const parsePathString = (pathString) => {
  // パスをスラッシュで分割
  const segments = pathString.split('/');

  // 会社情報（最初のセグメント）から数字とアンダースコアを除去
  let company = null;
  if (segments.length > 0) {
    const companyMatch = segments[0].match(/\d+_(.+)/);
    company = companyMatch ? companyMatch[1] : segments[0];
  }

  // ファイル名（最後のセグメント）
  const file = segments.length > 2 ? segments[segments.length - 1] : null;

  // タイトル（ファイル名から拡張子を除いた部分）
  let title = null;
  if (file) {
    // 最後の「.」以降を拡張子として扱い、それを除いた部分をタイトルとする
    const lastDotIndex = file.lastIndexOf('.');
    if (lastDotIndex === -1) {
      // 拡張子がない場合はファイル名全体をタイトルとする
      title = file;
    } else {
      // 拡張子を除いたファイル名部分をタイトルとする
      title = file.substring(0, lastDotIndex);
    }
  }
  return {
    company,
    title
  };
}